import React from 'react';
import { YELLOW } from '../const';

const SVG = ({ style = {}, color = YELLOW, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="4" fill="none">
      <circle cx="50" cy="50" r="46" strokeWidth="8" />
      <path d="M 24,28 C25,35 25,45 40,50" />
      <path d="M 76,28 C75,35 75,45 60,50" />
      <path fill={color} d="M 36,23.8 62,23.8 C64,75 36,75 38,23.8" />
      <line x1="22.2" y1="29" x2="77.8" y2="29" />
      <line x1="50" y1="60" x2="50" y2="73" strokeWidth="6" />
      <path d="M 45,74 L 55,74 60,82 40,82" fill={color} stroke="none" />
    </g>
  </svg>
);

export default SVG;
